module.exports = __webpack_public_path__ + "static/media/logo-linkedin.a997afa3.svg";